import React from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Snackbar,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const SnackbarCustomization = () => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Simple snackbars
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          A basic snackbar that aims to reproduce Google Keep's snackbar
          behavior.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              "  const [open, setOpen] = React.useState(false);\n" +
              "\n" +
              "  const handleClick = () => {\n" +
              "    setOpen(true);\n" +
              "  };\n" +
              "\n" +
              "  const handleClose = (event, reason) => {\n" +
              '    if (reason === "clickaway") {\n' +
              "      return;\n" +
              "    }\n" +
              "\n" +
              "    setOpen(false);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              '    <Stack direction="column" spacing={2} sx={{ width: "100%" }}>\n' +
              '      <Button variant="outlined" onClick={handleClick}>\n' +
              "        Open success snackbar\n" +
              "      </Button>\n" +
              "      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>\n" +
              "        <Alert\n" +
              '          variant="filled"\n' +
              "          onClose={handleClose}\n" +
              '          severity="success"\n' +
              '          sx={{ width: "100%" }}\n' +
              "        >\n" +
              "          This is a success message!\n" +
              "        </Alert>\n" +
              "      </Snackbar>\n" +
              '      <Alert variant="filled" severity="error">\n' +
              "        This is an error message!\n" +
              "      </Alert>\n" +
              '      <Alert variant="filled" severity="warning">\n' +
              "        This is a warning message!\n" +
              "      </Alert>\n" +
              '      <Alert variant="filled" severity="info">\n' +
              "        This is an information message!\n" +
              "      </Alert>\n" +
              '      <Alert variant="filled" severity="success">\n' +
              "        This is a success message!\n" +
              "      </Alert>\n" +
              "    </Stack>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <Stack direction={"column"} spacing={2} sx={{ width: "100%" }}>
              <Button variant="outlined" onClick={handleClick}>
                Open success snackbar
              </Button>
              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
              >
                <Alert
                  variant="filled"
                  onClose={handleClose}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  This is a success message!
                </Alert>
              </Snackbar>
              <Alert variant="filled" severity="error">
                This is an error message!
              </Alert>
              <Alert variant="filled" severity="warning">
                This is a warning message!
              </Alert>
              <Alert variant="filled" severity="info">
                This is an information message!
              </Alert>
              <Alert variant="filled" severity="success">
                This is a success message!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default SnackbarCustomization;
